var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect6, _rect7, _rect8, _path9, _rect9, _rect0, _g, _rect1, _rect10, _rect11, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 240,
    viewBox: "0 0 301 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 120,
    r: 120,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 111.493,
    height: 16.6637,
    rx: 2.53332,
    transform: "matrix(1 0 0 -1 82.9698 166.107)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 111.493,
    height: 16.6637,
    rx: 2.53332,
    transform: "matrix(1 0 0 -1 82.9698 166.107)",
    fill: "#001733"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.9698 69.375C82.9698 66.2684 85.4882 63.75 88.5948 63.75H189.374C192.48 63.75 194.999 66.2684 194.999 69.375V142.31C194.999 143.709 193.865 144.843 192.465 144.843H85.5032C84.1041 144.843 82.9698 143.709 82.9698 142.31V69.375Z",
    fill: "#002F66"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.0514,
    y: 67.5636,
    width: 103.866,
    height: 73.4662,
    rx: 2.53332,
    fill: "#EBEEF7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5972,
    y: 116.154,
    width: 62.7156,
    height: 20.6914,
    rx: 3.61902,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7917,
    y: 126.5,
    width: 23.9386,
    height: 5.98464,
    rx: 2.99232,
    fill: "url(#paint0_linear_194_3574)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5972 74.9962C90.5972 72.9974 92.2175 71.3771 94.2162 71.3771H149.694C151.692 71.3771 153.313 72.9974 153.313 74.9962V121.326C153.313 122.326 152.503 123.136 151.503 123.136H92.4067C91.4073 123.136 90.5972 122.326 90.5972 121.326V74.9962Z",
    fill: "#F5F6FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.203 81.9973C106.203 85.1039 103.685 87.6223 100.578 87.6223C97.4718 87.6223 94.9534 85.1039 94.9534 81.9973C94.9534 78.8907 97.4718 76.3723 100.578 76.3723C103.685 76.3723 106.203 78.8907 106.203 81.9973Z",
    fill: "url(#paint1_linear_194_3574)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.811 80.5911L99.7993 83.6031C99.7287 83.6738 99.6141 83.6738 99.5434 83.6031L98.3887 82.4484",
    stroke: "#0E1214",
    strokeWidth: 1.80951,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M115.821 81.9973H111.27",
    stroke: "black",
    strokeWidth: 3.61902,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M98.5425 94.8461H139.076",
    stroke: "#18223D",
    strokeWidth: 5.06663,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M98.5425 104.979H139.076",
    stroke: "#18223D",
    strokeWidth: 5.06663,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M98.5425 115.113H139.076",
    stroke: "#18223D",
    strokeWidth: 5.06663,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98.6445,
    y: 144.227,
    width: 19.3359,
    height: 2.52171,
    fill: "#18223D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 147.755,
    y: 143.839,
    width: 17.4165,
    height: 2.27139,
    fill: "#18223D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 111.493,
    height: 16.6637,
    rx: 2.53332,
    transform: "matrix(1 0 0 -1 82.9698 162.773)",
    fill: "#002F66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.463 74.9961C156.463 72.9974 158.083 71.3771 160.082 71.3771H185.641C187.639 71.3771 189.26 72.9974 189.26 74.9961V135.036C189.26 136.036 188.45 136.846 187.45 136.846H158.273C157.273 136.846 156.463 136.036 156.463 135.036V74.9961Z",
    fill: "#F5F6FB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 165.439,
    y: 128.641,
    width: 53.0351,
    height: 58.1628,
    rx: 8.03571,
    fill: "#001733"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 53.1535,
    height: 89.1427,
    rx: 7.03125,
    transform: "matrix(1 0 0 -1 165.38 182.927)",
    fill: "#002F66"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.277,
    y: 177.112,
    width: 3.32381,
    height: 3.87576,
    rx: 1.66191,
    fill: "#18223D"
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 44.7484,
    height: 75.4335,
    rx: 4.01786,
    transform: "matrix(1 0 0 -1 169.583 173.515)",
    fill: "#EBEEF7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 172.025,
    y: 148.23,
    width: 39.8651,
    height: 22.4646,
    rx: 4.01786,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 179.315,
    y: 159.462,
    width: 26.5767,
    height: 6.64418,
    rx: 3.32209,
    fill: "url(#paint2_linear_194_3574)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M172.025 103.634C172.025 101.415 173.824 99.6162 176.043 99.6162H207.872C210.091 99.6162 211.89 101.415 211.89 103.634V153.802C211.89 154.911 210.99 155.81 209.881 155.81H174.034C172.924 155.81 172.025 154.911 172.025 153.802V103.634Z",
    fill: "#F5F6FB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M186.046 109.031H180.994",
    stroke: "black",
    strokeWidth: 4.01786,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M202.921 109.031C202.921 112.138 200.402 114.656 197.296 114.656C194.189 114.656 191.671 112.138 191.671 109.031C191.671 105.925 194.189 103.406 197.296 103.406C200.402 103.406 202.921 105.925 202.921 109.031Z",
    fill: "url(#paint3_linear_194_3574)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199.529 107.625L196.531 110.623C196.452 110.701 196.325 110.701 196.247 110.623L195.106 109.482",
    stroke: "#0E1214",
    strokeWidth: 2.00893,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.364 126.471H205.344",
    stroke: "#18223D",
    strokeWidth: 5.625,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.364 137.721H205.344",
    stroke: "#18223D",
    strokeWidth: 5.625,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.364 148.971H205.344",
    stroke: "#18223D",
    strokeWidth: 5.625,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_194_3574",
    x1: 112.241,
    y1: 131.022,
    x2: 110.763,
    y2: 124.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F58EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_194_3574",
    x1: 95.4221,
    y1: 77.9342,
    x2: 108.99,
    y2: 84.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493056,
    stopColor: "#38EF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02CCCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_194_3574",
    x1: 197.578,
    y1: 164.483,
    x2: 195.937,
    y2: 156.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F58EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_194_3574",
    x1: 192.14,
    y1: 104.968,
    x2: 205.708,
    y2: 111.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493056,
    stopColor: "#38EF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02CCCD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.4ce9298d267d6a14fd70d3716595771d.svg";
export { ForwardRef as ReactComponent };